import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import {
  ContentContainer,
  LayoutWrapper,
  SidebarContainer
} from "components/Layouts/styled";

import { ClickSideBarExpand } from "assets/SVGComponents";
import SideBar from "components/SideBar/index";

const Layout = () => {
  const [isSidebarPinned, setIsSidebarPinned] = useState(() => {
    const saved = localStorage.getItem("isSidebarPinned");
    return saved === "true";
  });
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);

  const handleTogglePin = () => {
    setIsSidebarPinned((prev) => {
      const newState = !prev;
      if (!newState) setIsSidebarHovered(false);
      localStorage.setItem("isSidebarPinned", newState);
      return newState;
    });
  };

  const handleMouseEnter = () => {
    if (!isSidebarPinned) setIsSidebarHovered(true);
  };

  const handleMouseLeave = () => {
    if (!isSidebarPinned) setIsSidebarHovered(false);
  };

  useEffect(() => {
    const handlePinSidebar = () => {
      setIsSidebarPinned(true);
      setIsSidebarHovered(false);
    };

    window.addEventListener("pinSidebarFromSidebar", handlePinSidebar);
    return () => {
      window.removeEventListener("pinSidebarFromSidebar", handlePinSidebar);
    };
  }, []);

  return (
    <LayoutWrapper>
      <SidebarContainer
        $isPinned={isSidebarPinned}
        $isHovered={isSidebarHovered}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="sidebar-content">
          <SideBar
            isHovered={isSidebarPinned || isSidebarHovered}
            setSidebarHovered={setIsSidebarHovered}
          />

          {/* /* ---------- Sidebar Expand/Collapse Button ---------- * / */}
          {/* <ClickSideBarExpand
            className={`click-side-bar-expand ${!isSidebarPinned ? "rotated" : ""}`}
            opacity="0.4"
            strokeWidth="16"
            strokeHeight="16"
            onClick={handleTogglePin}
          /> */}
        </div>
      </SidebarContainer>
      <ContentContainer $isPinned={isSidebarPinned}>
        <Outlet />
      </ContentContainer>
    </LayoutWrapper>
  );
};

export default Layout;
